import { render, staticRenderFns } from "./AddInquiryReviewModal.vue?vue&type=template&id=299e452e&"
import script from "./AddInquiryReviewModal.vue?vue&type=script&lang=js&"
export * from "./AddInquiryReviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports